<template>
  <div class="returnCar-list">
    <el-tabs v-model="activeTabName" type="card" @tab-click="handleTabClick">
      <el-tab-pane
        v-for="item in tabList"
        :key="item.key"
        :label="`${item.label} (${item.value || 0})`"
        :name="item.name"
      ></el-tab-pane>
    </el-tabs>

    <base-list-management
      ref="baseListManagement"
      :configData.sync="configData"
    >
      <div slot="custom-operate">
        <el-button
          v-if="judgePermission('return_lease_start')"
          type="primary"
          @click="handelAddPersonalReturnCar"
          >个人客户还车</el-button
        >
        <el-button
          v-if="judgePermission('return_lease_ent_start')"
          type="primary"
          @click="handelAddEnterpriseReturnCar"
          >企业客户还车</el-button
        >
        <el-button
          v-if="judgePermission('return_lease_batch_start')"
          type="primary"
          @click="() => handelReturnCarModalVisibleChange(true)"
          >批量发起还车</el-button
        >
      </div>
    </base-list-management>

    <return-car-modal
      :visible="returnCarModalVisible"
      @handelReturnCarModalVisibleChange="handelReturnCarModalVisibleChange"
    ></return-car-modal>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import { searchByCustomerNameSensitive } from '@/api/domain/customers'
import {
  cancelReturnCarBook,
  getReturnCarStatistics,
  cancelReturnCar,
} from '@/api/domain/returnLease'
import ReturnCarModal from './components/returnCarModal'
import { FuzzySearch } from '@/api/domain/cars'
import { RETURN_CAR_ORDER_STATES } from '@/pages/cars/returnCar/config'
import { TAB_LIST, mixin } from './config'

export default {
  mixins: [mixin],
  data() {
    return {
      activeTabName: RETURN_CAR_ORDER_STATES.all.value,
      tabList: JSON.parse(JSON.stringify(TAB_LIST)),
      // minxin里有调用
      // eslint-disable-next-line vue/no-unused-properties
      carIdSearchLoading: false,
      // minxin里有调用
      // eslint-disable-next-line vue/no-unused-properties
      customerIdSearchLoading: false,
      returnCarModalVisible: false,
    }
  },
  methods: {
    init() {
      this.getReturnCarStatistics()
    },
    // 获取车辆列表 mixin有调用
    // eslint-disable-next-line vue/no-unused-properties
    async gerCarList(query) {
      query = query.trim()

      let carList

      if (query.length >= 4) {
        this.$refs.baseListManagement.setItemData({
          elConfigKey: 'loading',
          key: 'carId',
          data: true,
        })
        try {
          const { code, data } = await FuzzySearch({
            plateNo: query,
            state: 1,
          })
          if (code === 1) {
            carList = data
          }
          this.$refs.baseListManagement.setItemData({
            elConfigKey: 'loading',
            key: 'carId',
            data: false,
          })
        } catch (err) {
          this.$refs.baseListManagement.setItemData({
            elConfigKey: 'loading',
            key: 'carId',
            data: false,
          })
        }
      } else {
        carList = []
      }

      this.$refs.baseListManagement.setItemData({
        elConfigKey: 'list',
        key: 'carId',
        data: carList,
      })
    },
    // 获取客户列表 mixin有调用
    // eslint-disable-next-line vue/no-unused-properties
    async getCustomerList(query) {
      query = query.trim()

      let customerIdList

      if (query.length >= 1) {
        this.$refs.baseListManagement.setItemData({
          elConfigKey: 'loading',
          key: 'customerId',
          data: true,
        })
        try {
          const { code, data = [] } = await searchByCustomerNameSensitive({
            customerName: query,
            customerState: 1,
            mixedType: 'YES',
          })
          if (code === 1) {
            customerIdList = data
          }
          this.$refs.baseListManagement.setItemData({
            elConfigKey: 'loading',
            key: 'customerId',
            data: false,
          })
        } catch (err) {
          this.$refs.baseListManagement.setItemData({
            elConfigKey: 'loading',
            key: 'customerId',
            data: false,
          })
        }
      } else {
        customerIdList = []
      }

      this.$refs.baseListManagement.setItemData({
        elConfigKey: 'list',
        key: 'customerId',
        data: customerIdList,
      })
    },
    // 获取客户还车各状态统计数据
    getReturnCarStatistics() {
      getReturnCarStatistics().then((res) => {
        const { code, data } = res
        if (code === 1) {
          if (data) {
            Object.keys(data).forEach((item) => {
              this.tabList.forEach((items) => {
                if (item === items.key) {
                  items.value = data[item]
                }
              })
            })
          }
        }
      })
    },
    handleTabClick() {
      this.reset()
    },
    // mixin有调用
    // eslint-disable-next-line vue/no-unused-properties
    dealWithSearch(params) {
      const _params = JSON.parse(JSON.stringify(params))
      const returnTimeStart =
        (_params.returnTime && _params.returnTime[0]) || ''
      const returnTimeEnd = (_params.returnTime && _params.returnTime[1]) || ''
      const bookTimeStart = (_params.bookTime && _params.bookTime[0]) || ''
      const bookTimeEnd = (_params.bookTime && _params.bookTime[1]) || ''
      const state = parseInt(this.activeTabName, 10) || undefined

      delete _params.returnTime
      // 品牌车系
      const { brandSeriesModel } = _params
      const brandId = brandSeriesModel.brandId
      const seriesId = brandSeriesModel.seriesId
      const modelId = brandSeriesModel.modelId
      delete _params.brandSeriesModel
      return {
        ..._params,
        returnTimeStart,
        returnTimeEnd,
        bookTimeStart,
        bookTimeEnd,
        state,
        brandId,
        seriesId,
        modelId,
      }
    },
    reset() {
      this.resetBaseListManagement()
    },
    resetBaseListManagement() {
      this.$refs.baseListManagement.reset()
    },
    refreshBaseListManagement() {
      this.$refs.baseListManagement.searchForm()
    },
    handelAddPersonalReturnCar() {
      this.$router.push('/returnLease/returnCar/personalAdd')
    },
    handelAddEnterpriseReturnCar() {
      this.$router.push('/returnLease/returnCar/enterpriseAdd')
    },
    handelReturnCarModalVisibleChange(visible) {
      this.returnCarModalVisible = visible
    },
    // 取消还车单 mixin有调用
    // eslint-disable-next-line vue/no-unused-properties
    async handleOrderCancel(order) {
      cancelReturnCar({
        id: order.id,
      }).then((res) => {
        const { code } = res
        if (code === 1) {
          this.$message.success('取消成功')
          this.refreshBaseListManagement()
        }
      })
    },
    // 退车预约单 取消操作 mixin有调用
    // eslint-disable-next-line vue/no-unused-properties
    async handleAppointmentCancel(row) {
      const { code } = await cancelReturnCarBook({ id: row.id }).catch(
        (err) => {
          if (err.code === 35321) {
            this.$message.error('司机已取消退车')
            this.refreshBaseListManagement()
          } else {
            this.$message.error(err.msg)
          }
        },
      )
      if (code === 1) {
        this.$message.success('取消成功')
        this.refreshBaseListManagement()
      }
    },
  },
  // 取消预约还扯
  created() {
    this.init()
  },
  components: {
    'return-car-modal': ReturnCarModal,
  },
}
</script>
